interface ModelLoaderProps {
  status: "idle" | "loading" | "ready" | "error";
  progress: number;
  error?: string;
  isIOS?: boolean;
}

export function ModelLoader({ status, progress, error, isIOS }: ModelLoaderProps) {
  if (status === "ready") return null;

  return (
    <div className="rounded-lg border bg-card p-4">
      {status === "idle" && (
        <p className="text-sm text-muted-foreground">
          {isIOS ? (
            <>
              Tap <span className="font-medium text-foreground">Enable Dictation</span> below to start.
              {" "}Transcription runs on the server (works great on mobile).
              {" "}You can also type directly in the editor without it.
            </>
          ) : (
            <>
              Tap <span className="font-medium text-foreground">Enable Dictation</span> below to load the speech model (~80MB, one-time download). You can also type directly in the editor without it.
            </>
          )}
        </p>
      )}
      {status === "loading" && !isIOS && (
        <div className="space-y-2">
          <p className="text-sm text-amber-500">
            Loading Whisper base.en model... {Math.round(progress)}%
          </p>
          <div className="h-2 w-full rounded-full bg-muted overflow-hidden">
            <div
              className="h-full bg-blue-500 rounded-full transition-all duration-300"
              style={{ width: `${progress}%` }}
            />
          </div>
          <p className="text-xs text-muted-foreground">
            First load downloads ~80MB (base.en), then cached by your browser.
          </p>
        </div>
      )}
      {status === "error" && (
        <p className="text-sm text-destructive">
          Failed to load model: {error}
        </p>
      )}
    </div>
  );
}
